<template>
  <el-option
    v-bind="$attrs"
    v-on="$listeners"
  >
    <slot>
      <my-tooltip placement="top" :content="$attrs.label" >
        <div>
          {{ $attrs.label || ''}}
        </div>
      </my-tooltip>
    </slot>
  </el-option>
</template>

<script>
  export default {
    name: "my-option",
    props: {

    },
    methods: {}
  }
</script>



// WEBPACK FOOTER //
// src/components/MyOption.vue